/* @flow */
import React from 'react'

import './style.css'

class Button extends React.Component {
  render() {
    const { type, text, icon, onClick } = this.props
    return <button className={ type || 'submit' } onMouseDown={(e) => {
      onClick(e)
      e.preventDefault()
      e.stopPropagation()
    }}>
      { icon ? icon : null } {text || 'Button'}
    </button>
  }
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/index.js